module.exports = __webpack_public_path__ + "img/bau-troi-day-sao.fba76769.webp";